<template>
  <fieldset>
    <FormulateInput
      name="remark"
      type="textarea"
      :label="i18n.form.labels.remark"
      validation="nohtml"
      :validation-messages="i18n.form.validations.remark"
    />

    <FormulateInput
      v-if="showContactRequest"
      name="contact"
      :options="{
        yes: i18n.form.labels.contactoptions.yes,
        no: i18n.form.labels.contactoptions.no,
      }"
      type="radio"
      :label="i18n.form.labels.contact"
      validation="required"
      :validation-messages="i18n.form.validations.contact"
    />

    <FormulateInput
      v-if="showContactType"
      name="contacttype"
      :options="{
        telephone: i18n.form.labels.contacttypeoptions.telephone,
        email: i18n.form.labels.contacttypeoptions.email,
        textmessage: i18n.form.labels.contacttypeoptions.textmessage,
      }"
      type="radio"
      :label="i18n.form.labels.contacttype"
      validation="required"
      :validation-messages="i18n.form.validations.contacttype"
    />
  </fieldset>
</template>

<script>
export default {
  name: 'FieldsRemark',
  props: {
    i18n: {
      type: Object,
      default: null,
    },
    model: {
      type: Object,
      default: () => {},
    },
    showContactRequest: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    showContactType() {
      return this.model.contact === 'yes';
    },
  },
};
</script>
